unit PrjClassHelperClasses;


interface

uses
  WEBLib.StdCtrls,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WEBLib.Grids,

  System.SysUtils,
  System.Classes,
  System.Rtti,
  System.TypInfo,
  System.StrUtils,
  System.Types,
  System.Generics.Collections,
  System.Generics.Defaults;


type
  THBMWebEdit = class(TEdit)
  private
    FIntegerValue: Integer;
    function GetIntegerValue: Integer;
  published
    property IntegerValue: Integer read GetIntegerValue;
  end;

  THBMWebStringGrid = class(TStringGrid)
  private
  published
  end;

  TTableProperties = class(TObject)
  public
    FAssignment: Integer;
    FPeriod: Integer;
    FContent : string;
    FOptionalIntField1 : integer;
    FPrevAssignment : integer;
    FSortOrder : integer;
  end;

type
  TTablePropertiesObjectList = class(TObjectList<TTableProperties>)
  private
  protected
    function GetItem(AIndex: Integer): TTableProperties;
    procedure SetItem(AIndex: Integer; const AValue: TTableProperties);
  public
    function Add(AItem: TTableProperties): Integer;
    function Extract(AItem: TTableProperties): TTableProperties;
    function FindAssignment(AIndex: Integer): TTableProperties;
    function FindPrevAssignment(AIndex: Integer): TTableProperties;
    function FindAssignmentByName(AName: String): Integer;


    function Remove(AItem: TTableProperties): Integer;
    function IndexOf(AItem: TTableProperties): Integer;
    procedure Insert(Index: Integer; AItem: TTableProperties);
    function First: TTableProperties;
    function Last: TTableProperties;
    procedure Sort; virtual;
    property Items[Index: Integer]: TTableProperties read GetItem write SetItem; default;
  end;

function Str_F_to_Str(ADoubleVal: double; ALength, APrecision: Integer): string;

function ColorToGridPropertyHex(AColor : TColor): string;


implementation

uses
  System.Math;


function Str_F_to_Str(ADoubleVal: double; ALength, APrecision: Integer): string;
var LFormatString : string;
var LIdx : integer;
begin
  LFormatString :=  '#,##0.';
  for Lidx := 0 to APrecision - 1 do
    LFormatString := LFormatString + '0';
  result := FormatFloat(LFormatString, ADoubleVal);
end;

function ColorToGridPropertyHex(AColor : TColor): string;
begin
  Result := '#' + ColorToHex(AColor);
end;


{ TTablePropertiesObjectList }
function TTablePropertiesObjectList.Add(AItem: TTableProperties): Integer;
begin
  Result := inherited Add(AItem);
end;

function TTablePropertiesObjectList.Extract(AItem: TTableProperties): TTableProperties;
begin
  Result := TTableProperties(inherited Extract(AItem));
end;

function TTablePropertiesObjectList.FindPrevAssignment(AIndex: Integer): TTableProperties;
var Lidx : Integer;
begin
  Result := nil;
  for Lidx := 0 to Count - 1 do
  begin
    if Items[lidx].FPrevAssignment = AIndex then
    begin
      Result := Items[lidx];
      Break;
    end;
  end;
end;

function TTablePropertiesObjectList.FindAssignment(AIndex: Integer): TTableProperties;
var Lidx : Integer;
begin
  if Count > 0 then
  begin
    Result := nil;
    for Lidx := 0 to Count - 1 do
    begin
      if Items[lidx].FAssignment = AIndex then
      begin
        Result := Items[lidx];
        Break;
      end;
    end;
  end;
end;

function TTablePropertiesObjectList.FindAssignmentByName(AName: String): Integer;
var Lidx : Integer;
begin
  Result := -1;
  if Count > 0 then
  begin
    for Lidx := 0 to Count - 1 do
    begin
      if UpperCase(Items[lidx].FContent) = UpperCase(AName) then
      begin
        Result := Items[lidx].FAssignment;
        Break;
      end;
    end;
  end;
end;

function TTablePropertiesObjectList.First: TTableProperties;
begin
  Result := TTableProperties(inherited First);
end;

function TTablePropertiesObjectList.GetItem(AIndex: Integer): TTableProperties;
begin
  Result := TTableProperties(inherited Items[AIndex]);
end;

function TTablePropertiesObjectList.IndexOf(AItem: TTableProperties): Integer;
begin
  Result := inherited IndexOf(AItem);
end;

procedure TTablePropertiesObjectList.Insert(Index: Integer; AItem: TTableProperties);
begin
  inherited Insert(Index, AItem);
end;

function TTablePropertiesObjectList.Last: TTableProperties;
begin
  Result := TTableProperties(inherited Last);
end;

function TTablePropertiesObjectList.Remove(AItem: TTableProperties): Integer;
begin
  Result := inherited Remove(AItem);
end;

procedure TTablePropertiesObjectList.SetItem(AIndex: Integer; const AValue: TTableProperties);
begin
  inherited Items[AIndex] := AValue;
end;

procedure TTablePropertiesObjectList.Sort;
begin
  inherited Sort(TComparer<TTableProperties>.Construct(
    function (const L, R: TTableProperties): integer
    begin
       if L.FAssignment = R.FAssignment then
        Result := 0
       else if L.FAssignment < R.FAssignment then
          Result := -1
       else
          Result := 1;
    end ));
end;

function THBMWebEdit.GetIntegerValue: Integer;
begin
  if not TryStrToInt(Self.Text, FIntegerValue) then
  begin
    FIntegerValue := 0;
  end;
  Result := FIntegerValue;
end;


end.
